<div class="flex justify-center items-center flex-col h-full text-center" *transloco="let t">
	<vis-ods-icon-component
		name="success"
		class="mr-xs"
		width="72px"
		height="72px"
	></vis-ods-icon-component>
	<beyond-online-headline
		[headline]="t(title)"
		[subHeadline]="t(subtitle)"
		size="xl"
	></beyond-online-headline>
	<p beyond-online-text class="text-body-l my-xl">{{ t(text) }}</p>
	<button
		[attr.data-testid]="'go-to-order-button'"
		beyond-online-button
		variant="primary"
		(click)="goToOrder()"
		class="w-full justify-center"
		[label]="t('generalComponents.addedToCardPopUpSuccess.buttons.order')"
	></button>
	<button
		[attr.data-testid]="'go-to-cart-button'"
		beyond-online-button
		(click)="goToCart()"
		class="w-full my-m justify-center"
		variant="secondary"
		[label]="t('generalComponents.addedToCardPopUpSuccess.buttons.cart')"
	></button>
	<button
		[attr.data-testid]="'go-to-home-button'"
		beyond-online-button
		[label]="t('generalComponents.addedToCardPopUpSuccess.buttons.home')"
		(click)="goToHome()"
		variant="tertiary"
		class="w-full justify-center"
	></button>
</div>
